
import dateFormat from 'vux/src/tools/date/format.js'

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
name: "Plan",
components: {
MyBtnReturn
},
data() {
return {
src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的图片
src2: require('@/assets/images/plan/wx_chai_oringe.png'), // 拆箱的图片
tableData: [],
isShowTable: true,
isShowLoading: false,
canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
isNoData: false,
noDataText: '', // 无数据时的文本
}
},
created() {
document.title = '计划查询';

if (this.$route.name === 'TodayPlan') {
this.tableDataUrl = apiUrl.todayPlan;
this.noDataText = '今日暂无计划'
} else {
this.tableDataUrl = apiUrl.tomorrowPlan;
this.noDataText = '明日暂无计划'
}
let data = {
openId: apiParams.openId,
companyId: apiParams.companyId,
code: apiParams.code,
};
this.getData(this.tableDataUrl, data)
},
methods: {
getData(url, data) {
this.isShowLoading = true;

this.$http({
method: 'post',
url: url,
data: data
}).then((res) => {
let resultData = res.data; 
let code = resultData.code;
let info = resultData.info; 
if (code === 412) {
this.showToast(info, 2000, 'warn');


this.isNoData = true;
this.noDataText = info
} else if (code === 500) {
this.showToast(info, 2000, 'warn')
} else {
let list = resultData.data.list || [];
this.tableData = list;
}
this.isShowLoading = false
}, (error) => {
this.isShowLoading = false;
console.error(error);
})

},
dateFormat(time) {
return dateFormat(time, 'YYYY-MM-DD HH:mm')
}
}
}



// WEBPACK FOOTER //
// ./src/components/siji/plan/Plan.vue